"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryObject = void 0;
class QueryObject {
    constructor(value) {
        if (!value) {
            return;
        }
        try {
            Object.assign(this, JSON.parse(value));
        }
        catch (_a) {
            console.error(`Couldn't decode value to object : ${value}`);
        }
    }
}
exports.QueryObject = QueryObject;
//# sourceMappingURL=query.model.js.map